import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const insightsPortalFlyersAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.Flyers],
    featureToggles: [FeatureToggle.InsightsPortalFlyersDashboard],
  },
  {
    permissions: [Permission.Flyers],
    warehouseFeatureToggles: [FeatureToggle.InsightsPortalFlyersDashboard],
    minICPlatformVersion: ICPlatformVersion.r2026_01_0,
  },
]
